"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FieldSet = _interopRequireDefault(require("../FieldSet"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _FieldSet["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/FieldSet.js
// module id = 531
// module chunks = 0